import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import Logo from "../../assets/logo.png";
import Button1 from "./buttons/button1/Button";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
    // Toggle body class for preventing background scrolling when menu is open
    document.body.classList.toggle('menu-open', !isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMenuOpen) {
        closeMenu();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMenuOpen]);

  return (
    <>
      <nav
        className={`navbar-container ${isScrolled ? "scrolled" : ""}`}
        aria-label="Main navigation"
      >
        <div className="nav-content">
          <div
            className="nav-header"
            onClick={handleLogoClick}
            role="button"
            tabIndex={0}
            aria-label="Go to homepage"
          >
            <img src={Logo} alt="PlayGG Logo" className="nav-logo-img" />
            <span className="funky-text">PlayGG</span>
          </div>

          <button
            onClick={toggleMenu}
            className="hamburger-menu"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span className="hamburger-icon">☰</span>
          </button>

          {/* Desktop links container inside navbar */}
          {window.innerWidth > 768 && (
            <div className="nav-links-container">
              <ul className="nav-links">
                <li><Link to="/" onClick={closeMenu} >Home</Link></li>
                <li><Link to="/explore" onClick={closeMenu}>Explore</Link></li>
                <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                <li className="partner-button">
                  <Link to="/business" onClick={closeMenu} className="partner-link">
                    Partner with us
                  </Link>
                </li>
                <li className="download-button">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.playgg&hl=en_IN"
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="download-link"
                    onClick={closeMenu}
                  >
                    Download Now
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>

      {/* Mobile links container outside navbar */}
      {window.innerWidth <= 768 && (
        <div style={{paddingTop:180}} className={`nav-links-container ${isScrolled ? "scrolled" : ""} ${isMenuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/explore" onClick={closeMenu}>Explore</Link></li>
            <li><Link to="/about" onClick={closeMenu}>About</Link></li>
            <li className="partner-button">
              <Link to="/business" onClick={closeMenu} className="partner-link">
                Partner with us
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;